import { render } from "./News18.vue?vue&type=template&id=79c2d3ab&scoped=true"
import script from "./News18.vue?vue&type=script&lang=js"
export * from "./News18.vue?vue&type=script&lang=js"

import "./News18.vue?vue&type=style&index=0&id=79c2d3ab&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79c2d3ab"]])

export default __exports__